export const convertObjectIntoQueryString =(params) => Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&');
